(() => {
  const desktopScrollLayout = window.matchMedia('(min-width: 990px)');
  const pageWrapper = document.querySelector('.page-wrapper');
  let scrollRepairFrame = 0;

  /**
   * Horizon normally scrolls `.page-wrapper` on desktop. This landing page
   * intentionally uses the document as its only vertical scroll container.
   * Horizon's global restoration code can nevertheless write a stale
   * `scrollTop` back to `.page-wrapper`, leaving two scroll offsets out of
   * sync and causing partially painted/blank content while scrolling back up.
   * Move that offset to the document and immediately reset the nested one.
   */
  const repairNestedScroll = () => {
    scrollRepairFrame = 0;
    if (!desktopScrollLayout.matches || !pageWrapper) return;

    const nestedScrollTop = pageWrapper.scrollTop;
    if (nestedScrollTop <= 0) return;

    const documentScrollTop = window.scrollY || document.scrollingElement?.scrollTop || 0;
    pageWrapper.scrollTop = 0;

    if (documentScrollTop <= 1) {
      window.scrollTo({ top: nestedScrollTop, left: 0, behavior: 'auto' });
    }
  };

  const scheduleScrollRepair = () => {
    if (scrollRepairFrame) window.cancelAnimationFrame(scrollRepairFrame);
    scrollRepairFrame = window.requestAnimationFrame(repairNestedScroll);
  };

  if (pageWrapper) {
    pageWrapper.addEventListener('scroll', scheduleScrollRepair, { passive: true });
    scheduleScrollRepair();
    window.addEventListener('pageshow', () => {
      window.requestAnimationFrame(scheduleScrollRepair);
    });
    desktopScrollLayout.addEventListener('change', scheduleScrollRepair);
  }

  const emitInteraction = (type, form) => {
    if (window.Shopify?.designMode) return;
    // Deliberately no form values, campaign identifiers, or external tags.
    const detail = form ? { type, form } : { type };
    document.dispatchEvent(new CustomEvent('mw-stkt:interaction', { detail }));
  };

  if (document.querySelector('.mw-stkt-hero')) {
    emitInteraction('landingpage_view');
  }

  const header = document.querySelector('[data-mw-stkt-header]');
  if (header) {
    const toggle = header.querySelector('[data-mw-stkt-nav-toggle]');
    const navigation = header.querySelector('[data-mw-stkt-nav]');
    const logo = header.querySelector('[data-mw-stkt-scroll-top]');

    logo?.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (navigation) navigation.dataset.open = 'false';

      // A sticky header is already in view; explicitly scroll the document.
      // Clear Horizon's nested offset so the existing repair cannot restore it.
      if (scrollRepairFrame) window.cancelAnimationFrame(scrollRepairFrame);
      scrollRepairFrame = 0;
      if (pageWrapper) pageWrapper.scrollTop = 0;
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      });
      logo.focus({ preventScroll: true });
    });

    if (toggle && navigation) {
      const setMenuState = (isOpen) => {
        toggle.setAttribute('aria-expanded', String(isOpen));
        navigation.dataset.open = String(isOpen);
      };

      toggle.addEventListener('click', () => {
        setMenuState(toggle.getAttribute('aria-expanded') !== 'true');
      });

      navigation.addEventListener('click', (event) => {
        if (event.target.closest('a')) setMenuState(false);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          setMenuState(false);
          toggle.focus();
        }
      });

      window.matchMedia('(min-width: 1051px)').addEventListener('change', (event) => {
        if (event.matches) setMenuState(false);
      });
    }
  }

  document.addEventListener('click', (event) => {
    const trackedElement = event.target.closest('[data-mw-stkt-event]');
    if (!trackedElement) return;

    emitInteraction(trackedElement.dataset.mwStktEvent);
  });

})();
